import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Scales/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class ScalesQueries extends VueCqrs
{
	runWorkspaceScalesListQueryV1(workspaceId: number)
	{
		const query = q.buildWorkspaceScalesListQueryV1(workspaceId);
		this.$query(query);
	}

	runTchScaleTemplatesListQueryV1(workspaceId: number)
	{
		const query = q.buildTchScaleTemplatesListQueryV1(workspaceId);
		this.$query(query);
	}

}